import React from 'react';
import { Download, FileText } from 'lucide-react';
import { Button } from '@roger/ui-components';
import type { WoundAttachmentResponse } from '../../services/api';
import DeleteAttachmentButton from '../medications/DeleteAttachmentButton';

interface WoundAttachmentRowProps {
  attachment: WoundAttachmentResponse;
  onDownload: (attachment: WoundAttachmentResponse) => void;
  onDelete: (attachmentId: string) => Promise<void>;
}

const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const formatDate = (iso: string): string =>
  new Date(iso).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

const WoundAttachmentRow: React.FC<WoundAttachmentRowProps> = ({
  attachment,
  onDownload,
  onDelete,
}) => (
  <div className='flex items-center justify-between p-2 border rounded-md bg-background'>
    <div className='flex items-center gap-2 min-w-0'>
      <FileText className='h-4 w-4 shrink-0 text-muted-foreground' />
      <div className='min-w-0'>
        <p className='text-xs font-medium truncate'>{attachment.file_name}</p>
        <p className='text-[11px] text-muted-foreground'>
          {formatFileSize(attachment.file_size)} &middot;{' '}
          {formatDate(attachment.created_at)}
        </p>
      </div>
    </div>
    <div className='flex items-center gap-0.5 shrink-0'>
      <Button
        variant='ghost'
        size='sm'
        className='h-7 w-7 p-0'
        onClick={() => onDownload(attachment)}
      >
        <Download className='h-3.5 w-3.5' />
      </Button>
      <DeleteAttachmentButton onDelete={() => onDelete(attachment.id)} />
    </div>
  </div>
);

export default WoundAttachmentRow;
